module.exports = __webpack_public_path__ + "img/Pilates.87c41ab1.png";